import { Link } from 'react-router-dom';
import { Button } from '../../ui/components/ui/button';

const AccessExpired = () => {
  return (
    <div className="w-full h-full" style={{ backgroundColor: '#f0f4fc' }}>
      <div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-20 w-5/12">
          <div className="text-center flex gap-6 items-center justify-center">
            <img src="https://dev.flow.7i7.de/7i7-logo.svg" alt="" className="w-[75px]" />
          </div>
          <div className="bg-white p-8 rounded-lg flex flex-col gap-6">
            <div className="space-y-4 text-center">
              <div className="mx-auto w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold text-slate-800">Zugriff abgelaufen</h2>
              <p className="text-slate-600 leading-relaxed">
                Der Link, den du verwendet hast, ist abgelaufen oder (mittlerweilen) ungültig. Dies kann passieren, wenn zu viel Zeit seit der
                Erstellung des Links vergangen ist, oder du ihn bereits einmal verwendet hast.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <Link to="/">
                <Button variant="outline" size="lg" className="w-full">
                  Zur Startseite
                </Button>
              </Link>
            </div>

            <div className="text-center text-sm text-slate-500">
              <p>
                Benötigst du Hilfe?{' '}
                <Link to="mailto:info@7i7.de?cc=fabio@7i7.de" className="text-[#5FD5DE] hover:underline">
                  Kontaktiere uns
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessExpired;
